export default "__VITE_ASSET__ubdIf3Tr__"